module.exports = __webpack_public_path__ + "static/media/clear_search.b4a4ada7.svg";